import Vue from "vue";
import VueRouter from "vue-router";
import {
  life,
  news,
  postnews,
  media,
  partners,
  volunteers,
  mobileapp,
  serafim,
  ru,
  kz,
  uz,
  fl,
  ka,
  kg,
  ne,
  ng,
  rsa
} from "./routes";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    life,
    news,
    postnews,
    media,
    partners,
    volunteers,
    mobileapp,
    serafim,
    ru,
    kz,
    uz,
    fl,
    ka,
    kg,
    ne,
    ng,
    rsa
  ]
});

export default router;
